import { configureStore } from '@reduxjs/toolkit';
import bookingReducer from './bookingSlice';
import { loadBookingState, saveBookingState } from '../../utils/helpers/bookingPersistence';

// Load persisted booking state from localStorage (browser only)
const preloadedBookingState = loadBookingState();

export const store = configureStore({
    reducer: {
        booking: bookingReducer,
    },
    preloadedState: preloadedBookingState
        ? { booking: preloadedBookingState }
        : undefined,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

// Persist booking slice to localStorage in the browser
// Subscribe to store changes and save booking state automatically
if (typeof window !== 'undefined') {
    store.subscribe(() => {
        const state = store.getState();
        saveBookingState(state.booking);
    });
}

// Type definitions for JavaScript usage
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch; 